import React from 'react';
import { motion } from 'framer-motion';

const features = [
  {
    feature: '🤖 Personalized AI for restaurants',
    kairos: true,
  },
  {
    feature: '🌍 Multilingual customer support',
    kairos: true,
  },
  {
    feature: '🧠 Learns your restaurant details',
    kairos: true,
  },
  {
    feature: '🎨 Fully white-labeled (logo, tone, style)',
    kairos: true,
  },
  {
    feature: '🧩 Integrates into your website seamlessly',
    kairos: true,
  },
  {
    feature: '📞 Handles reservations + enquiries',
    kairos: true,
  },
  {
    feature: '🛠️ Completely customizable per client',
    kairos: true,
  },
  {
    feature: '⚡ Built for speed and ease-of-use',
    kairos: true,
  },
];

const WhatMakesDifferentNew: React.FC = () => {
  return (
    <section id="why-different" className="py-20 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-width-container">
        <motion.div 
          className="text-center mb-16"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            🚀 Why Kairos?
          </h2>
          <p className="text-xl text-slate-700 max-w-3xl mx-auto">
            More than a chatbot. A partner for digital hospitality.
          </p>
        </motion.div>

        <motion.div 
          className="bg-white rounded-3xl shadow-xl overflow-hidden"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.2 }}
        >
          {/* Table Header */}
          <div className="bg-gradient-to-r from-blue-600 to-emerald-600 p-6">
            <div className="grid grid-cols-2 gap-4">
              <div className="text-white">
                <h3 className="text-xl font-bold">Feature</h3>
              </div>
              <div className="text-center text-white">
                <h3 className="text-xl font-bold">Kairos</h3>
              </div>
            </div>
          </div>

          {/* Table Content */}
          <div className="divide-y divide-gray-100">
            {features.map((item, index) => (
              <motion.div
                key={index}
                className="grid grid-cols-2 gap-4 p-6 hover:bg-blue-50 transition-colors duration-200"
                initial={{ opacity: 0, x: -20 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
              >
                <div className="flex items-center">
                  <span className="text-slate-800 font-medium">
                    {item.feature}
                  </span>
                </div>
                <div className="flex items-center justify-center">
                  <motion.div
                    initial={{ scale: 0 }}
                    whileInView={{ scale: 1 }}
                    viewport={{ once: true }}
                    transition={{ 
                      duration: 0.3, 
                      delay: index * 0.1 + 0.2,
                      type: "spring",
                      stiffness: 200 
                    }}
                  >
                    {item.kairos ? (
                      <span className="inline-flex items-center justify-center w-8 h-8 bg-green-100 text-green-600 rounded-full">
                        ✅
                      </span>
                    ) : (
                      <span className="inline-flex items-center justify-center w-8 h-8 bg-red-100 text-red-600 rounded-full">
                        ❌
                      </span>
                    )}
                  </motion.div>
                </div>
              </motion.div>
            ))}
          </div>
        </motion.div>

        <motion.div 
          className="mt-12 text-center"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.6 }}
        >
          <div className="bg-gradient-to-r from-blue-50 to-emerald-50 rounded-2xl p-8 max-w-4xl mx-auto">
            <p className="text-lg text-slate-800 leading-relaxed">
              We don't just offer a service — we help you build your 
              <span className="text-blue-600 font-bold"> AI front desk</span> tailored to your brand.
            </p>
            
            <div className="mt-8 flex flex-col sm:flex-row gap-4 justify-center">
              <motion.button
                className="bg-gradient-to-r from-blue-600 to-emerald-600 text-white px-8 py-3 rounded-full font-medium hover:from-blue-700 hover:to-emerald-700 transition-all duration-300 shadow-lg hover:shadow-xl"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
              >
                Get Started Today
              </motion.button>
              <motion.button
                className="border-2 border-blue-500 text-blue-600 px-8 py-3 rounded-full font-medium hover:bg-blue-50 transition-all duration-300"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
              >
                Schedule a Demo
              </motion.button>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default WhatMakesDifferentNew;